import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=64d40748"
import script from "./ReservationForm.vue?vue&type=script&lang=js"
export * from "./ReservationForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationForm.vue?vue&type=style&index=0&id=64d40748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports